import React, { FormEventHandler, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { Organization } from "../common/ObjectTypes";
import { AttentionIcon } from "../common/ProjectIcons";

type OrganizationModalProps = {
    organization: Organization,
    onChange: Function,
    onToggleModal: MouseEventHandler,
    onSave: FormEventHandler
    newOrg: boolean,
    errors: any,
}

const OrganizationModal = ({
    organization,
    onChange,
    onToggleModal,
    onSave,
    newOrg,
    errors,
}: OrganizationModalProps) => {
    const { t } = useTranslation();
    return (
        <div className="fixed inset-0 z-50">
            <div className="fixed inset-0 bg-dark-gray opacity-80 transition-colors duration-300"
                onClick={onToggleModal}></div>
            <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
                <div className="z-20 flex flex-col bg-white w-full sm:w-5/6 md:w-3/4 lg:w-2/3 xl:w-1/2 shadow rounded-lg transition-colors duration-300">
                    <div className="bg-white z-30 sticky top-0 rounded-lg transition-colors duration-300">
                        <div className="flex flex-row-reverse">
                            <button
                                type="button"
                                onClick={onToggleModal}
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-3 ml-auto inline-flex items-center transition-colors duration-300"
                                data-modal-hide="authentication-modal"
                            >
                                <svg aria-hidden="true" className="w-7 h-7 text-off-black transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                <span className="sr-only">{t("Close Modal")}</span>
                            </button>
                        </div>
                    </div>
                    <div className="px-6 pb-6 lg:px-8">
                        <div className="flex justify-between">
                            <h1 className="text-3xl font-semibold text-off-black transition-colors duration-300">{newOrg ? t("Add") : t("Update")} {t("Workspace")}</h1>
                        </div>
                        <div onSubmit={onSave}>
                            <div className="flex flex-col my-5">
                                <div>
                                    {/* name and description */}
                                    <div className="flex flex-col w-1/2 mb-3">
                                        <label className="text-off-black transition-colors duration-300">{t("Name")}*</label>
                                        <input
                                            id="name"
                                            placeholder=""
                                            className="my-2 p-1.5 border border-neutral-gray-200 rounded text-off-black transition-all duration-300"
                                            value={organization.name}
                                            onChange={(e) => onChange(e)}>
                                        </input>
                                        {errors.name && <div className="text-orange-600 py-1 rounded flex flex-row items-center transition-colors duration-300"><AttentionIcon /><p className="ml-1 mt-0.5">{errors.name}</p></div>}
                                    </div>
                                    <div className="flex flex-col w-1/2">
                                        <label className="text-off-black transition-colors duration-300">{t("Description")}</label>
                                        <input
                                            id="description"
                                            placeholder=""
                                            className="my-2 p-1.5 border border-neutral-gray-200 rounded text-off-black transition-all duration-300"
                                            value={organization.description}
                                            onChange={(e) => onChange(e)}>
                                        </input>
                                    </div>
                                </div>
                                {/* submit and cancel button */}
                                <div className="flex flex-row-reverse mt-6">
                                    <button className="bg-dark-green hover:bg-status-green text-white font-bold rounded px-7 py-2 ml-2 shadow transition-colors duration-300"
                                        type="submit"
                                        onClick={onSave}>
                                        {newOrg ? t("Create") : t("Save")}
                                    </button>
                                    <button className="bg-light-gray hover:bg-gray-lines text-off-black font-bold rounded px-7 py-2 mx-2 transition-colors duration-300"
                                        type="button"
                                        onClick={onToggleModal}>
                                        {t("Cancel")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrganizationModal;